module.exports = __webpack_public_path__ + "img/right2.bbbfcbc1.svg";